import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createElementVNode as _$ce, className as _$cn, noop as _$no, createVNode as _$cv } from 'intact-vue-next';
import { Transition } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
var _$tmp0 = {
  'cx': '60',
  'cy': '60',
  'r': '57'
};
var _$tmp1 = {
  'viewBox': '0 0 120 120'
};
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    size = _this$get.size,
    center = _this$get.center,
    className = _this$get.className,
    overlay = _this$get.overlay;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-spin"] = true, _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[k + "-center"] = !overlay && center, _classNameObj[k + "-overlay"] = overlay, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var canvas = _$ce(2, 'div', (_$blocks['canvas'] = function ($super) {
    return _$ce(512, 'svg', _$ce(2, 'circle', null, 1, _$cn(k + "-spin-circle"), _$tmp0), 2, null, _$tmp1);
  }, __$blocks['canvas'] = function ($super, data) {
    var block = $blocks['canvas'];
    var callBlock = function callBlock() {
      return _$blocks['canvas'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['canvas'](_$no)), 0, _$cn(k + "-spin-canvas"));
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), overlay ? _$ce(2, 'div', canvas, 0, _$cn(k + "-spin-wrapper")) : canvas);
}
;